import { render } from "./FeaturedCarousel.vue?vue&type=template&id=72c0e562&scoped=true"
import script from "./FeaturedCarousel.vue?vue&type=script&lang=js"
export * from "./FeaturedCarousel.vue?vue&type=script&lang=js"

import "./FeaturedCarousel.vue?vue&type=style&index=0&id=72c0e562&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3966428095/src/eelam-tv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c0e562"]])

export default __exports__